import { render, staticRenderFns } from "./AdditionalStorage.vue?vue&type=template&id=b9f54f3a&"
import script from "./AdditionalStorage.vue?vue&type=script&lang=js&"
export * from "./AdditionalStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports